import React from 'react';

export default ({ color = '#221CB6', size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill={color} />
    <path
      d="M3.60234 6.1499L3.82605 8.07548C3.85783 8.34556 4.09956 8.5499 4.38731 8.5499H7.61172C7.89947 8.5499 8.14119 8.34556 8.17299 8.07548L8.39952 6.1499H8.39669"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 4.9502H9" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    <path
      d="M5.02499 3L3.89999 4.95H4.19999"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.97501 3L8.10001 4.95H7.80001"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
